import React from "react";
import { Link } from "react-router-dom";

const HomePage = () => {
    return (
        <div className=" flex flex-col items-center justify-center bg-darkblue text-lightgray">
            <div className="flex flex-col items-center text-center px-4 py-10 max-w-3xl mx-auto">
                <h1 className="text-3xl sm:text-4xl font-bold text-lightgray mb-3">
                    Your First Hire Is Free
                </h1>
                <p className="text-lg font-normal text-lightgray mb-2">
                    Clone your superstar. We&apos;ll find the match.
                </p>
                <p className="text-lg font-bold text-lightblue mb-8">
                    Candidates never pay
                </p>
            </div>

            {/* Call-to-Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 w-full max-w-2xl">
                <Link
                    to="/employer-signup"
                    className="w-full sm:w-1/2 py-6 px-10 bg-orange hover:bg-deeporange text-white text-center text-xl sm:text-2xl font-bold rounded-lg shadow-lg transition duration-300 flex flex-col justify-center items-center active:scale-95"
                >
                    <span>Join as an Employer</span>
                </Link>
                <Link
                    to="/candidate-signup"
                    className="w-full sm:w-1/2 py-6 px-10 border-2 border-orange text-orange hover:bg-orange hover:text-white bg-transparent text-center text-xl sm:text-2xl font-bold rounded-lg shadow-lg transition duration-300 flex flex-col justify-center items-center active:scale-95"
                >
                    <span>Join as a Candidate</span>
                </Link>
            </div>

            {/* Video Section */}
            <div className="max-w-6xl mt-16 py-4 w-full px-4 sm:px-0">
                <h3 className="text-3xl font-bold text-center mb-6">
                    How Career Mission Works
                </h3>
                <div className="flex flex-col sm:flex-row gap-12">
                    {/* Employer Video */}
                    <div className="w-full sm:w-1/2 text-center">
                        <h4 className="text-2xl font-bold mb-4">For Employers</h4>
                        <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
                                src="https://www.youtube.com/embed/I-DhAqkmPlA?rel=0&vq=hd1080"
                                title="Employer Video"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>

                    {/* Candidate Video */}
                    <div className="w-full sm:w-1/2 text-center">
                        <h4 className="text-2xl font-bold mb-4">For Candidates</h4>
                        <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
                                src="https://www.youtube.com/embed/VLY4DBsUML0?rel=0&vq=hd1080"
                                title="Candidate Video"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomePage;
